// Components/shared/ProfileAvatar.jsx

import { AiFillCamera } from 'react-icons/ai'
import Avatar from '../../Components/shared/chat/avatar'

const ProfileAvatar = ({
  image,
  firstName,
  lastName,
  size = 'w-[120px] h-[120px] text-xl',
  editable = false,
  onEdit,
}) => {
  return (
    <div className="relative">
      {image ? (
        <Avatar
          image={image}
          width={size}
          profile={true}
        />
      ) : (
        <Avatar
          fname={firstName}
          lname={lastName}
          width={size}
        />
      )}

      {editable && (
        <button
          type="button"
          onClick={onEdit}
          className="absolute bottom-0 right-0 bg-everglade-600 border-2 border-white rounded-full w-7 h-7 flex items-center justify-center text-white hover:bg-everglade-700"
        >
          <AiFillCamera size={14} />
        </button>
      )}
    </div>
  )
}

export default ProfileAvatar